import React from "react";
import InstitutionLogo from "../../assets/Images/elementary-logo.png";
import BgImage from "../../assets/Images/customReceipt-bg.png";
import "../../styles/ComponentsStyles/Universal/CustomBill.style.css";

const fallbackItems = [
  { item: "Notebook", quantity: 5, unit: "pcs", unitPrice: 50 },
  { item: "Pencils", quantity: 10, unit: "pcs", unitPrice: 10 },
  { item: "Chart Paper", quantity: 2, unit: "sheets", unitPrice: 30 },
];

const backup = {
  institution: "Elementary School of Business and Social Sciences",
  receiptId: "123456789",
  date: "02 Oct, 2025",
  time: "10:30 AM",
  billTitle: "MATERIAL & RESOURCES BILL",
  taxPercent: 10,
  items: fallbackItems,
  vendorInfo: {
    vendorName: "Dummy Vendor",
    vendorContact: "0000000000",
    paidAmount: 500,
    confirmedBy: "System Admin",
    paymentMode: "Cash",
  },
};

const CustomBill = ({ data = fallbackItems, vendorInfo = backup.vendorInfo }) => {
  const {
    institution,
    receiptId,
    date,
    time,
    taxPercent,
    billTitle,
  } = backup;

  const billData = data?.length ? data : fallbackItems;

  const {
    vendorName = "Unknown Vendor",
    vendorContact = "N/A",
    paidAmount = 0,
    confirmedBy = "N/A",
    paymentMode = "N/A",
  } = vendorInfo;

  const subTotal = billData.reduce(
    (acc, item) => acc + (item?.quantity || 0) * (item?.unitPrice || 0),
    0
  );

  const taxAmount = (subTotal * taxPercent) / 100;
  const netTotal = subTotal + taxAmount;
  const dueAmount = netTotal - paidAmount;

  return (
    <div
      style={{
        position: "relative",
        backgroundSize: "cover",
        backgroundImage: `url(${BgImage})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "816px",
        width: "566px",
        fontFamily: "Poppins-regular",
        padding: "2rem",
      }}
      className="custom-bill"
    >
      <div className="institution-name">
        <img src={InstitutionLogo} alt="logo" />
        <h3>{institution}</h3>
      </div>

      <div className="bill-title">
        <h4>{billTitle}</h4>
      </div>

      <div
        style={{
          paddingBottom: "2rem",
          borderBottom: "2px dashed var(--grayColor)",
          fontSize: "small",
        }}
        className="bill-info"
      >
        <div className="id-date">
          <div className="receipt-id">
            <span>Receipt ID:</span> {receiptId}
          </div>
          <div className="date-time">
            <span>Date & time:</span> {date} {time}
          </div>
        </div>

        <div className="name-contact">
          <div className="name">
            <span>Vendor Name:</span> {vendorName}
          </div>
          <div className="contact">
            <span>Contact:</span> {vendorContact}
          </div>
        </div>
      </div>

      <div className="bill-table-container table-scroll">
        <table>
          <thead>
            <tr>
              <th>Items ({billData.length})</th>
              <th>Order Size</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {billData.map((item, index) => (
              <tr key={index}>
                <td>{item?.item || "Unnamed Item"}</td>
                <td>
                  {item?.quantity || 0} {item?.unit || ""}
                </td>
                <td>₹ {(item?.quantity || 0) * (item?.unitPrice || 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="totalContainer">
        <div className="subSection">
          <div className="subTotal">
            <span>Sub Total:</span>
            <span>₹ {subTotal.toLocaleString("en-IN")}</span>
          </div>
          <div className="taxes">
            <span>Other tax (GST, SGST, CGST) in %</span>
            <span className="taxPercentage">{taxPercent}</span>
            <span>₹ {taxAmount.toLocaleString("en-IN")}</span>
          </div>
        </div>
        <div className="calculation">
          <div className="netTotal">
            <span>Total:</span>
            <span>₹ {netTotal.toLocaleString("en-IN")}</span>
          </div>
          <div className="paidAmount">
            <span>Paid amount:</span>
            <span>₹ {paidAmount.toLocaleString("en-IN")}</span>
          </div>
          <div className="dueAmount">
            <span>Due amount:</span>
            <span>₹ {dueAmount.toLocaleString("en-IN")}</span>
          </div>
        </div>
      </div>
      <div className="paymentDetails">
        <div className="paymentMode">
          <span>Payment Mode:</span>
          <span>{paymentMode}</span>
        </div>
        <div className="confirmedBy">
          <span>Confirmed By:</span>
          <span>{confirmedBy}</span>
        </div>
      </div>
      <div className="signature">
        <span id="seal">Official Seal</span>
        <span id="signatory">Authorised Signatory</span>
      </div>
    </div>
  );
};

export default CustomBill;
